export const userControlledFieldInitialState = {
  payload: ''
}

export type UserControlledFieldState = typeof userControlledFieldInitialState
